/*  Simple login page.*/
import { observer } from "mobx-react";
import * as React from "react";
import { Redirect, RouteComponentProps, withRouter } from "react-router-dom";

import * as HelperSrc from "../../HelperSrc";
import { lang } from "../../lang";
import { store as uiStore } from "../../store/ui";
import { login } from "../../actions/login";
import { Form } from "../../components/comp/Form";
import { Input } from "../../components/comp/Form/Input";
import { Button } from "../../components/atoms/Button";
import { CenteredContent } from "../../components/atoms/CenteredContent";
import { Dropdown } from "../../components/molecules/Dropdown";
import { catchEndpoint } from "../../catchEndpoint";
import { adLogin, adInit, adResetStatus } from "../../actions/adLogin";
import { changeLanguage } from "../../actions/changeLanguage";
import { clearApplication } from "../../actions/clearApplication";
import { MenuItem } from "../../interface";
import LangIcon from "@mui/icons-material/Language";
import MuiIconButton from "@mui/material/IconButton";
import MuiIconLayersClear from "@mui/icons-material/LayersClear";

@observer
class LoginPageBase extends React.Component<
    RouteComponentProps & {
        appName?: string;
    }
> {
    state = {
        apiLoading: false
    };

    public login = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        this.setState({ apiLoading: true });

        const { username, psw } = uiStore.loginForm;

        login(username, psw)
            .then((success) => {
                if (!success) {
                    this.setState({ apiLoading: false });
                }
            })
            .catch(catchEndpoint);
    };

    public loginAd = () => {
        localStorage.setItem(`${HelperSrc.LABEL}_ad_init_status`, "1");
        localStorage.setItem(`${HelperSrc.LABEL}_ad_working_status`, "1");
        uiStore.setLoaded(false);

        adInit()
            .then(() => {
                return adLogin();
            })
            .catch(() => {
                this.props.history.push(HelperSrc.ROUTE_TYPE.LOGIN);
                adResetStatus();
            });
    };

    public clearApplication = () => {
        this.setState({ apiLoading: true });

        clearApplication()
            .then(() => {
                this.setState({ apiLoading: false });
            })
            .catch(catchEndpoint);
    };

    public render() {
        const { appName } = this.props;

        if (uiStore.userid) {
            return <Redirect to="/clients" />;
        }

        return (
            <div className="view_login">
                <div className="left">
                    <div className="content">
                        <h1>{appName}</h1>
                    </div>
                </div>
                <div className="right">
                    <div className="menu">
                        <Dropdown
                            icon={LangIcon}
                            title={""}
                            data-at_id="menu_locale"
                            items={[
                                { key: "ja-JP", name: lang.japanese, "data-at_id": "menu_locale_ja_jp" },
                                { key: "en-US", name: lang.english, "data-at_id": "menu_locale_en_us" }
                            ]}
                            onClick={(e: MenuItem) => {
                                const localeSplit = e.key.split("-");
                                const language = localeSplit[0];
                                const country = localeSplit[1].toLowerCase();

                                changeLanguage(language, country);
                            }}
                        />
                        <MuiIconButton data-at_id="clear_application" onClick={this.clearApplication}>
                            <MuiIconLayersClear />
                        </MuiIconButton>
                    </div>
                    <div className="content">
                        <h1 data-at_id="welcome">{lang.welcome}</h1>
                        {(() => {
                            const html: JSX.Element[] = [];

                            if (HelperSrc.ENV_NAME === "local" || HelperSrc.ENV_NAME === "dev_jp" || HelperSrc.ENV_NAME === "dev_us") {
                                html.push(
                                    <React.Fragment key="logout_form_box">
                                        <CenteredContent>
                                            <Form to={"/"} statename="loginForm" onSubmit={this.login}>
                                                <Input
                                                    id="username-input"
                                                    data-at_id="username"
                                                    context={uiStore}
                                                    stateName={"username"}
                                                    placeholder={lang.userName}
                                                />
                                                <Input
                                                    id="password-input"
                                                    data-at_id="password"
                                                    context={uiStore}
                                                    type={"password"}
                                                    stateName={"psw"}
                                                    placeholder={lang.psw}
                                                />
                                                <Button
                                                    id="login-button"
                                                    data-at_id="login_button"
                                                    title={lang.login}
                                                    loading={this.state.apiLoading}
                                                    submit
                                                ></Button>
                                            </Form>
                                        </CenteredContent>
                                    </React.Fragment>
                                );
                            }

                            html.push(
                                <React.Fragment key="white_box">
                                    <div className="ad_login">
                                        <CenteredContent>
                                            <Button id="activedirectory-button" title={lang.adLogin} onClick={this.loginAd} />
                                        </CenteredContent>
                                    </div>
                                </React.Fragment>
                            );

                            return html;
                        })()}
                    </div>
                </div>
            </div>
        );
    }
}

const LoginPage = withRouter(LoginPageBase);

export { LoginPage };
